<template>
  <div id="May2025" class="202505">
    <div>
      <div class="mb-6">
        <img src="~@/assets/images/202505/head.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202505/m/head.png" class="object-contain mx-auto md:hidden">
      </div>
      <a class="mb-6 block" href="https://store.liveabc.com/products/recent/sale?tag=487" target="_blank">
        <img src="~@/assets/images/202505/Frame1.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202505/m/Frame1.png" class="object-contain mx-auto md:hidden">
      </a>
      <a class="mb-6 block" href="https://store.liveabc.com/products/recent/sale?tag=488" target="_blank">
        <img src="~@/assets/images/202505/Frame2.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202505/m/Frame2.png" class="object-contain mx-auto md:hidden">
      </a>
      <div class="mb-6">
        <div>
          <img src="~@/assets/images/202505/section4_title.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202505/m/section4_title.png" class="object-contain mx-auto md:hidden">
        </div>

        <div class="flex flex-wrap max-w-6xl mx-auto books rounded p-2">
          <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/3 md:w-1/4 p-3 border border-black border-dashed" v-for="(item, index) in bookData" :key="index"
            :class="{ 'md:border-t-0': ([0, 1, 2, 3].indexOf(index) > -1), 'md:border-r-0': ([3, 7, 11, 15, 19].indexOf(index) > -1), 'md:border-b-0': ([16, 17, 18, 19].indexOf(index) > -1), 'md:border-l-0': ([0, 4, 8, 12, 16].indexOf(index) > -1)}">
            <img :src="item.img_url" class="object-contain block mx-auto">
          </router-link>
        </div>

        <a class="p-6 block" target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=485">
          <img src="~@/assets/images/202505/bt-more.png" class="object-contain mx-auto">
        </a>
      </div>

      <div class="mb-6 p-2">
        <div class="books max-w-6xl mx-auto pb-4">
          <img src="~@/assets/images/202505/section5_title.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202505/m/section5_title.png" class="object-contain mx-auto md:hidden">
        </div>
        <div class="flex flex-wrap max-w-6xl mx-auto books rounded p-2">
          <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/3 md:w-1/4 p-3 border border-black border-dashed" v-for="(item, index) in bookData2" :key="index" :class="{ 'md:border-t-0': ([0, 1, 2, 3].indexOf(index) > -1), 'md:border-r-0': ([3, 7, 11, 15, 19].indexOf(index) > -1), 'md:border-b-0': ([4, 5, 6, 7].indexOf(index) > -1), 'md:border-l-0': ([0, 4, 8, 12, 16].indexOf(index) > -1)}">
            <img :src="item.img_url" class="object-contain block mx-auto">
          </router-link>
        </div>
        <div class="books max-w-6xl mx-auto py-4">
          <img src="~@/assets/images/202505/section5_title2.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202505/m/section5_title2.png" class="object-contain mx-auto md:hidden">
        </div>
        <div class="flex flex-wrap max-w-6xl mx-auto books rounded p-2">
          <a class="w-1/4 md:w-1/5 p-3 border border-black border-dashed" v-for="(item, index) in bookData3" :key="index" :class="{ 'md:border-t-0': ([0, 1, 2, 3, 4].indexOf(index) > -1), 'md:border-r-0': ([4, 9].indexOf(index) > -1), 'md:border-b-0': ([5, 6, 7, 8, 9].indexOf(index) > -1), 'md:border-l-0': ([0, 5].indexOf(index) > -1)}">
            <img :src="item.img_url" class="object-contain block mx-auto">
          </a>
        </div>
        <a class="p-6 block" target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=489">
          <img src="~@/assets/images/202505/bt-more.png" class="object-contain mx-auto">
        </a>
      </div>

      <footer class="z-20">
        <router-link :to="{ name: 'index' }" class="mx-auto mb-4 z-20"><img src="~@/assets/images/202505/foot.png" class="object-contain mx-auto max-w-5xl z-20"></router-link>
      </footer>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '超省錢書展💰｜LiveABC教你省錢有道!',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: false,
      bookData: [
        { id: 10708, img_url: require('@/assets/images/202505/book/item1.png') },
        { id: 10528, img_url: require('@/assets/images/202505/book/item2.png') },
        { id: 9601, img_url: require('@/assets/images/202505/book/item3.png') },
        { id: 7582, img_url: require('@/assets/images/202505/book/item4.png') },
        { id: 9440, img_url: require('@/assets/images/202505/book/item5.png') },
        { id: 7287, img_url: require('@/assets/images/202505/book/item6.png') },
        { id: 7231, img_url: require('@/assets/images/202505/book/item7.png') },
        { id: 10694, img_url: require('@/assets/images/202505/book/item8.png') },
        { id: 8465, img_url: require('@/assets/images/202505/book/item9.png') },
        { id: 7219, img_url: require('@/assets/images/202505/book/item10.png') },
        { id: 10775, img_url: require('@/assets/images/202505/book/item11.png') },
        { id: 10586, img_url: require('@/assets/images/202505/book/item12.png') },
        { id: 10685, img_url: require('@/assets/images/202505/book/item13.png') },
        { id: 10550, img_url: require('@/assets/images/202505/book/item14.png') },
        { id: 10340, img_url: require('@/assets/images/202505/book/item15.png') },
        { id: 9317, img_url: require('@/assets/images/202505/book/item16.png') },
        { id: 8926, img_url: require('@/assets/images/202505/book/item17.png') },
        { id: 10274, img_url: require('@/assets/images/202505/book/item18.png') },
        { id: 10235, img_url: require('@/assets/images/202505/book/item19.png') },
        { id: 6572, img_url: require('@/assets/images/202505/book/item20.png') }
      ],
      bookData2: [
        { id: 10788, img_url: require('@/assets/images/202505/package/item1.png') },
        { id: 10486, img_url: require('@/assets/images/202505/package/item2.png') },
        { id: 8882, img_url: require('@/assets/images/202505/package/item3.png') },
        { id: 8728, img_url: require('@/assets/images/202505/package/item4.png') },
        { id: 8739, img_url: require('@/assets/images/202505/package/item5.png') },
        { id: 7005, img_url: require('@/assets/images/202505/package/item6.png') },
        { id: 10242, img_url: require('@/assets/images/202505/package/item7.png') },
        { id: 7388, img_url: require('@/assets/images/202505/package/item8.png') }
      ],
      bookData3: [
        { id: 8142, img_url: require('@/assets/images/202505/package2/item1.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item2.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item3.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item4.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item5.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item6.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item7.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item8.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item9.png') },
        { id: 8142, img_url: require('@/assets/images/202505/package2/item10.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#May2025 {
  background: #FFE964;
  .books {
    background-color: #FFFCE7;
  }
.top-line {
  width: 100%;
  height: 49px;
  background-image: url('~@/assets/images/202503/line_up.png');
  background-repeat: repeat-x;
  background-size: contain;
  background-position: center;
  @media (max-width: 767px) {
    background-size: cover;
  }
}
.bottom-line {
  width: 100%;
  height: 49px;
  background-image: url('~@/assets/images/202503/line_up.png');
  background-repeat: repeat-x;
  background-size: contain;
  background-position: center;
  transform: rotate(180deg);
  @media (max-width: 767px) {
    background-size: cover;
  }
}
.menu-bg {
  background-color: #002A32F2;
}
.web-menu {
  top: 10%;
}
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    left: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    left: -174px;
    transition: 0.3s;
  }
  .main {
    background-color: #FE6D48;
    @media (max-width: 767px) {
      padding-top: 56px;
    }
    .top {
      background-image: url('~@/assets/images/202503/cloud1.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center bottom;
    }
  }
}
</style>
